import { PrivateUser } from "../../../hooks/useUser";
import { with_comma } from "../../../util/comma";
import React, { useContext } from "react";
import Btn from "../../layout/Btn";
import { actionContext } from "../../../app/page";
import api from "../../../util/api";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faC, faP, faUser } from "@fortawesome/free-solid-svg-icons";
import swal from 'sweetalert';
import NavIcon from "../../layout/navIcon";

export function Userinfo({ user, mutateUser }: { user: PrivateUser, mutateUser: any }) {

    function PointExchangeCash() {
        api(`/api/user/exchange-point`, { method: 'POST' })
            .then(e => mutateUser(undefined))
            .catch(e => swal({
                text: '포인트전환 오류가 발생했습니다.',
                icon: "error",
            })
            )
    }
    function logout() {

        api(`/api/user/logout`)
            .then(e => mutateUser(undefined))
            .catch(e => swal({
                text: "로그아웃 실패",
                icon: "error",
            })
            )
    }
    return (
        <div className={'user-btn'}>
            <div className="status">
                {/* <NavIcon type="user" /> */}
                {user.nickname}
            </div>
            <span className="line"></span>
            <div className="status">
                <b>{with_comma(user.money)}</b>
                원
            </div>
            {
                user.point > 0
                    ? <>
                        <span className="line"></span>
                        <div className="status">
                            <b>{with_comma(user.point)}</b>
                            P
                        </div>
                        <Btn className="green" onClick={PointExchangeCash}>포인트 전환</Btn>
                    </>
                    : <></>
            }
            <Btn className="dark-purple" onClick={logout}>로그아웃</Btn>
        </div>
    )
}

export function UserBtn() {
    const { SetLoginPop, SetRegisterPop } = useContext(actionContext)
    return (
        <>
            <div className={"user-btn unUser"}>
                <Btn className={'green'} onClick={SetLoginPop}>로그인</Btn>
                <Btn className={'purple'} onClick={SetRegisterPop}>회원가입</Btn>
            </div>
        </>
    )
}